import React from 'react';
import PropTypes from 'prop-types';

import Icon from '../Icon';
import Logo from '../../svg/icons/logo.svg';

const IconLogo = (props) => {
  const { fill, height, width } = props;
  return (
    <Icon
      component={Logo}
      fill={fill}
      height={height}
      name="logo"
      width={width}
    />
  );
};

IconLogo.displayName = 'IconLogo';

IconLogo.propTypes = {
  fill: PropTypes.string,
  height: PropTypes.string,
  width: PropTypes.string,
};

IconLogo.defaultProps = {
  fill: '#ff462d',
  height: '40',
  width: '90',
};

export default IconLogo;
